import { type ReactNode, useRef } from "react";
import { DialogContext } from "@/hooks/DialogContext";
import { createDialogueStore } from "@/store/store";
import type { DialogueConfig } from "@/store/types";

interface DialogProviderProps {
	children: ReactNode;
	config?: DialogueConfig;
}

/**
 * 对话提供者组件
 * 创建对话状态管理器并提供给子组件
 */
export const DialogProvider = ({ children, config }: DialogProviderProps) => {
	const storeRef = useRef(createDialogueStore(config ?? {}));

	return (
		<DialogContext.Provider value={storeRef.current}>
			{children}
		</DialogContext.Provider>
	);
};
